import {combineReducers} from 'redux';

import appState from './appState';
import autoProfileState from './autoProfileState';
import debugStore from './debugStore';
import {deviceInfoStore} from './deviceInfoStore';
import {deviceStore} from './deviceStore';
import loadingState from './loadingState';
import loadingStore from './loadingStore';
import {manualControlStore} from './manualControlStore';
import modalState from './modalState';
import modalStore from './modalStore';
import schedulerState from './schedulerState';
import setupStore from './setupStore';
import signalRState from './signalRState';
import timeZoneStore from './timeZoneStore';
import toastState from './toastState';
import {updateSystemStore} from './updateSystemStore';

const rootReducer = combineReducers({
  appState,
  loadingState,
  modalState,
  signalRState,
  toastState,
  //
  setupStore,
  loadingStore,
  modalStore,
  debugStore,
  deviceInfoStore,
  updateSystemStore,
  manualControlStore,
  deviceStore,
  autoProfileState,
  timeZoneStore,
  schedulerState,
});

export default rootReducer;
